export const trackingEvents = {
  INVOICING: {
    NEW_WORKERS_STARTING_CSV: { CLICKED: 'invoicing.new_workers_starting_csv.clicked' },
    OVERPAYMENTS_CSV: { CLICKED: 'invoicing.overpayments_csv.clicked' },
    LAST_MONTHS_JOBS: { CLICKED: 'invoicing.last_months_jobs.clicked' },
  },
}
